export function getOverlappingRange(rangeA, rangeB) {
    // e.g. A = [5, 7], B = [6, 8], return [6-7]

    let minimumPh = Math.max(rangeA[0], rangeB[0])
    let maximumPh = Math.min(rangeA[1], rangeB[1])

    if(minimumPh > maximumPh || maximumPh < minimumPh) {
        return null
    }

    return [minimumPh, maximumPh]
}

export function getOverlappingRangeFromArray(ranges) {
    let cumulativeRange = null

    let sortedRanges = ranges.sort((a, b) => {
        return a[0] - b[0]
    })

    for (let index = 0; index < sortedRanges.length; index++) {
        let hasNextItem = typeof sortedRanges[index + 1] !== 'undefined'
        let currentAndNextItemRange = null

        if(hasNextItem) {
            currentAndNextItemRange = getOverlappingRange(sortedRanges[index], sortedRanges[index + 1])
        } else if (cumulativeRange === null) {
            // Return the only range provided
            return sortedRanges[index]
        }

        if(currentAndNextItemRange === null) {
            continue
        }

        if(cumulativeRange === null) {
            cumulativeRange = currentAndNextItemRange
        } else {
            let combinedRange = getOverlappingRange(cumulativeRange, currentAndNextItemRange)

            // Check this is not an outlier
            if(combinedRange) {
                cumulativeRange = combinedRange
            }
        }
    }

    return cumulativeRange
}